export enum Step {
  UploadReview = "upload_review",
  RecapVariance = "recap_variance",
  Identify = "identify",
  Missing = "missing",
  Opportunities = "opportunities",
  Packet = "packet"
}

export const STEP_ORDER: Step[] = [
  Step.UploadReview,
  Step.Identify,
  Step.Packet
];
